import { atom } from 'jotai';

export const globalVariables = atom({
    loading: false,
    userName: '',
    userPhoto: '',
});
